import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { SharedModule } from '../../shared.module';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-material-pg-button',
  templateUrl: './material-pg-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SharedModule, MatInputModule, MatFormFieldModule, MatButtonModule],

})

export class MaterialPgButtonComponent {
  @Input() id!: string;

  @Input() set label(value: string) {
    if (value) {
      this._label = value;
    }
  }

  @Input() set disabled(value: boolean) {
    this._disabled = value;
  }

  _disabled!: boolean;
  _label = '';

  @Output() clicked = new EventEmitter<boolean>();

  click() {
    this.clicked.emit(true);
  }

}
